import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React from 'react';

import ExternalAuthorizationForm from '../../shared/ExternalAuthorizationForm/ExternalAuthorizationForm';

export const ExternalUrlRouter = (props) => {
  return (
    <ExternalAuthorizationForm serviceType={props.match.params.serviceType} />
  );
};

export default withRouter(connect(ExternalUrlRouter));
